import React from 'react';
import { Contact } from '../components/Contact';
export function Contacto() {
  return <div className="pt-24" data-id="element-427">
      <Contact data-id="element-428" />
    </div>;
}